










































































import { Component, Provide, Vue } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
import Constants from '@/constants';

@Component({
  props: ['organizationId'],
})
export default class ExportModal extends Vue {
  @Provide()
  public useGlobalFormatExport: boolean = false;
  public isExportProcessed: boolean = false;
  public isExportFail: boolean = false;
  private request: any = null;

  get allowExport() {
    return this.$auth.user().isLr ||
          (this.$auth.user().isRdkm &&
           this.$auth.user().functionsRouteName.includes('ExportGlobalRelativeDonors'));
  }

  get exportUrl() {
    let url =
      Constants.baseUrl + '/donorsRelative/Export?userId=' + this.$auth.user().id;

    if (this.useGlobalFormatExport) {
      url += '&useGlobalFormatExport=true';
    }

    if (this.$auth.user().isRdkm) {
      url += '&organizationId=' + this.$props.organizationId;
    }

    return url;
  }

  public showModal() {
    this.useGlobalFormatExport = this.$auth.user().isRdkm;
    this.isExportProcessed = false;
    this.isExportFail = false;
    this.$root.$emit('bv::show::modal', 'export-donors-modal');
  }

  public hideModal() {
    if (this.request) {
      this.request.cancel('user_cancel');
    }

    this.$root.$emit('bv::hide::modal', 'export-donors-modal');
    this.$emit('closeModal');
  }

  public exportDonors() {
    const CancelToken = axios.CancelToken;
    this.request = CancelToken.source();
    this.isExportProcessed = true;
    this.isExportFail = false;

    axios({
      url: this.exportUrl,
      method: 'GET',
      responseType: 'blob',
      cancelToken: this.request.token,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        const fileName = this.$t('Экспорт доноров') + `, ${
          this.useGlobalFormatExport ? this.$t('глобавльный') : this.$t('локальный')
        } - ${moment().format('DD.MM.YYYY')}.xlsx`;

        this.isExportProcessed = false;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        this.hideModal();
        // @ts-ignore
        this.$swal({ title: this.$t('Файл со списком доноров сформирован!'), icon: "success" });
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          this.isExportFail = true;
          this.isExportProcessed = false;
        }
      });
  }
}
